import * as store from '@attain-apps/fe/web/main/lib/store'
import * as rxjs from 'rxjs'

import type { Plugin } from '../plugin'

/** Writes one entity selection into the in-memory lookup. */
export const setSelection = store.effects.create(
  (feature: Plugin['feature'], selectionStorage: Plugin['selectionStorage']) =>
    feature.actions.setSelection.relay((forwardTo, { entityId, recordIds }) =>
      feature.selectors.selectionLookup.asObservable.pipe(
        rxjs.take(1),
        rxjs.map(current => {
          const lookup = { ...current }

          if (recordIds.length > 0) {
            lookup[entityId] = recordIds
          } else {
            delete lookup[entityId]
          }

          return forwardTo(selectionStorage.actions.setLookup, {
            input: lookup,
          })
        }),
      ),
    ).asObservable,
)
